import { Spinner } from "react-bootstrap";
import { useGetMyOpeningBalanceCorrectionsQuery } from "../../../store/member/member-contribution";
import { formatMoney } from "../../../utils/currencyFormat";

/**
 * Member-readable history of staff adjustments to imported opening balances.
 */
export default function ImportedBalanceCorrectionsPanel() {
  const { data, isLoading, isFetching } = useGetMyOpeningBalanceCorrectionsQuery({
    page: 1,
    limit: 50,
  });

  const rows = data?.data ?? [];

  if (isLoading || isFetching) {
    return (
      <div className="py-5 text-center">
        <Spinner animation="border" size="sm" />
      </div>
    );
  }

  if (!rows.length) {
    return (
      <p className="text-muted small mb-0">
        No staff corrections to your imported balance have been recorded.
      </p>
    );
  }

  return (
    <div className="w-full">
      <p className="text-secondary small mb-3">
        These entries are <strong>not</strong> regular contributions. Staff may
        adjust imported opening figures; each line shows the balance before and
        after that correction.
      </p>
      <ul className="list-unstyled mb-0">
        {rows.map((row) => (
          <li
            key={row.id}
            className="border rounded p-3 mb-3"
            style={{ borderColor: "#e0e0e0" }}
          >
            <div className="fw-bold text-dark">
              {row.category?.name ?? "Savings category"}
              <span className="text-muted fw-normal ms-2 small">
                · Cutover {row.cutover_date}
              </span>
            </div>
            <div className="mt-1 small">
              {formatMoney(Number(row.previous_total).toFixed(2))}
              <span className="text-muted mx-1">→</span>
              {formatMoney(Number(row.new_total).toFixed(2))}
            </div>
            {row.recorded_by ? (
              <div className="text-muted mt-1" style={{ fontSize: 12 }}>
                Recorded by {row.recorded_by.first_name}{" "}
                {row.recorded_by.last_name}
              </div>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
